import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import ToastNotification from '../toast_notification';
import { API_CONFIG } from '../../config/api';

interface ModalRedefinirSenhaProps {
  show: boolean;
  onHide: () => void;
}

const email = localStorage.getItem('email')
const ModalRedefinirSenha: React.FC<ModalRedefinirSenhaProps> = ({ show, onHide }) => {
  const [showToast, setShowToast] = useState(false);
  
  const handleSubmit = () => {
    fetch(`${API_CONFIG.BASE_URL}/cadastros/usuarios/redefinir-senha/solicitar`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email: localStorage.getItem('email')
      })
    }).then((response) => {
    }).catch((error) => {
      setShowToast(false);
    }); 
    setShowToast(true);
  };

  useEffect(() => {
    if (!showToast) return;
    const t = setTimeout(() => {
      setShowToast(false);
      onHide();
    }, 5000);
    return () => clearTimeout(t);
  }, [showToast, onHide]);
  return (
    <Modal 
      show={show}
      onHide={onHide}
      className="hana-modal"
      centered
    >
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="hana-modal-title">
          Redefinir senha
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="pt-4">
        <p>O email de redefinição de senha será enviado para: <strong>{email}</strong></p>
      </Modal.Body>
      <Modal.Footer className="border-0 pt-0">
        <Button 
          variant="outline-secondary" 
          className="hana-button me-2"
          onClick={onHide}
        >
          Cancelar
        </Button>
        <Button 
          variant="primary" 
          className="hana-button-primary"
          onClick={handleSubmit}
        >
          Redefinir
        </Button>   
      </Modal.Footer>
      {showToast && (
        <ToastNotification
          status={200}
          message="Senha redefinida com sucesso"
          onClose={() => {
            setShowToast(false);
            onHide();
          }}
        />
      )}
    </Modal>
  );
};

export default ModalRedefinirSenha; 